import {
  ARColzaAzoteFrequency,
  ARColzaAzoteProductType,
  ARColzaOrderType,
  ARColzaOrganicProductType,
} from './agrorendement-colza-lists.model';
import {
  ARConsoleFormatType,
  ARConsoleModulationType,
  ARConsoleType,
  ARConsoleVersion,
  ARFertilizerType,
} from './agrorendement-common-lists.model';
import { Campaign } from './campaign.model';
import { Parcel } from './parcel.model';

export class ARColzaCampaign extends Campaign {
  configuration: ARColzaCampaignConfiguration;
}

export class ARColzaCampaignConfiguration {
  id: number;
  startingOn: string | Date;
  endingOnEh: string | Date;
  endingOnSh: string | Date;

  createdAt: string | Date;
  updatedAt: string | Date;

  campaign: ARColzaCampaign;
}

export class ARColzaOrder {
  id: number;
  campaign: ARColzaCampaign;
  orderItems: ARColzaOrderItem[];

  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ARColzaOrderItem {
  id: number = null;

  ehCompleted: boolean = null;
  shCompleted: boolean = null;
  order: ARColzaOrder = null;
  orderType: ARColzaOrderType = null;
  needsCarteEpandage: boolean = false;

  objective: number = null;

  suspended: boolean = null;
  defaultWeek: Date = null;

  pastAzoteProductType: ARColzaAzoteProductType = null;
  pastAzoteFrequency: ARColzaAzoteFrequency = null;

  fallFirstOrganicProductType: ARColzaOrganicProductType = null;
  fallFirstOrganicConcentration: number = null;
  fallFirstOrganicDensity: number = null;

  fallSecondOrganicProductType: ARColzaOrganicProductType = null;
  fallSecondOrganicConcentration: number = null;
  fallSecondOrganicDensity: number = null;

  hasCouvertLegumineuses: boolean = null;
  hasReliquatSortieHiver: boolean = null;
  reliquatSortieHiver: number = null;

  // données EH
  ehAzoteToSpread: number = null;

  ehFertilizerType: ARFertilizerType = null;
  ehFertilizerConcentration: number = null;

  ehConsoleModulationType: ARConsoleModulationType = null;
  ehConsoleType: ARConsoleType = null;
  ehConsoleVersion: ARConsoleVersion = null;
  ehOtherConsoleVersion: string = null;
  ehConsoleFormatType: ARConsoleFormatType = null;

  //donéées SH (pas de préfixe pour raison historique)
  fertilizerType: ARFertilizerType = null;
  fertilizerConcentration: number = null;

  consoleModulationType: ARConsoleModulationType = null;
  consoleType: ARConsoleType = null;
  consoleVersion: ARConsoleVersion = null;
  otherConsoleVersion: string = null;
  consoleFormatType: ARConsoleFormatType = null;

  hasMicroParcels: boolean = null;

  createdAt: string | Date = null;
  updatedAt: string | Date = null;

  parcel: ARColzaParcel = null;

  //dates planning
  eh_date_livraison: Date = null;
  sh_date_livraison: Date = null;
}

export class ARColzaParcel extends Parcel {
  orderItem: ARColzaOrderItem;
}
